import React from "react";
import { Button, Label } from "reactstrap";

const STATUS_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'show', label: 'Show' },
  { value: 'pending', label: 'Pendente' },
  { value: 'noShow', label: 'No Show' },
];

export default function CommandButtons({
  search,
  setSearch,
  schedules,
  scheduleFilter,
  setScheduleFilter,
  statusFilter,
  setStatusFilter,
  groupFilter,
  setGroupFilter,
  groups,
  refreshData,
  getReport,
  getGeneralReport,
}) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "flex-end",
        marginBottom: 10,
        gap: 10,
        flexWrap: "wrap",
      }}
    >
      <form
        className="app-search d-none d-lg-block events-input-search"
        onSubmit={(e) => e.preventDefault()}
      >
        <Label className="mb-1">Buscar Participante</Label>
        <div className="position-relative">
          <input
            value={search}
            type="text"
            className="form-control"
            placeholder="Buscar por nome, e-mail, CPF, código interno ou instituição..."
            onChange={(e) => setSearch(e.target.value)}
          />
          <span className="bx bx-search-alt" />
        </div>
      </form>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          gap: 10,
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Label className="mb-1">Programação</Label>
          <select
            className="form-select"
            style={{ width: "auto", minWidth: 200 }}
            value={scheduleFilter}
            onChange={(e) => setScheduleFilter(e.target.value)}
          >
            {schedules.map((schedule) => (
              <option key={schedule.id} value={schedule.id}>
                {schedule.title}
              </option>
            ))}
          </select>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Label className="mb-1">Status</Label>
          <select
            className="form-select"
            style={{ width: "auto", minWidth: 150 }}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Label className="mb-1">Grupo</Label>
          <select
            className="form-select"
            style={{ width: "auto", minWidth: 150 }}
            value={groupFilter}
            onChange={(e) => setGroupFilter(e.target.value)}
          >
            <option value="">Todos os Grupos</option>
            <option value="no-group">Sem Grupo</option>
            {groups.map((group) => (
              <option key={group.id} value={group.id}>
                {group.text}
              </option>
            ))}
          </select>
        </div>
        <Button
          color="secondary"
          className="waves-effect waves-light"
          style={{ display: "flex", alignItems: "center", gap: 6 }}
          onClick={refreshData}
        >
          <i className="fas fa-sync-alt" />
          Atualizar
        </Button>
        <Button
          color="success"
          className="waves-effect waves-light"
          style={{ display: "flex", alignItems: "center", gap: 6 }}
          onClick={getReport}
        >
          <i className="fas fa-file-excel" />
          Extrair Relatório
        </Button>
        <Button
          color="primary"
          className="waves-effect waves-light"
          style={{ display: "flex", alignItems: "center", gap: 6 }}
          onClick={getGeneralReport}
        >
          <i className="fas fa-table" />
          Relatório Geral
        </Button>
      </div>
    </div>
  );
}
